import Control from "./Control.js"

export default class PauseOverlay extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-pause-overlay", true)
    this.state.altText = "MSG_PLAY"
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onClick() {
    const player = this.player
    switch (player.playState) {
      case "ended":
        this.plugin.replay()
      break

      default:
        player.play()
      break
    }
  }
}
